import React from 'react';
import { Grid, makeStyles, Paper } from '@material-ui/core';
import cx from 'clsx';

interface AnnouncementPanelProps {
  Actions?: JSX.Element;
  Header?: JSX.Element;
  show?: boolean;
  borderColor?: string;
  className?: string;
  children?: React.ReactNode;
}

export const AnnouncementPanel = ({
  Actions,
  Header,
  show,
  borderColor,
  className,
  children
}: AnnouncementPanelProps) => {
  const classes = useStyles({ borderColor });

  if (!show) return null;

  return (
    <Paper elevation={3} className={classes.root}>
      <Grid container spacing={2} alignItems="center" justify="space-between">
        <Grid item>
          {Header}
          {children && <div className={cx(className)}>{children}</div>}
        </Grid>
        {Actions && <Grid item>{Actions}</Grid>}
      </Grid>
    </Paper>
  );
};

const useStyles = makeStyles(theme => ({
  root: ({ borderColor }: { borderColor?: string }) => ({
    padding: theme.spacing(3),
    borderLeftStyle: 'solid',
    borderLeftWidth: theme.spacing(1),
    borderLeftColor: borderColor ?? theme.palette.primary.main
  })
}));

export default AnnouncementPanel;
